import { Navbar } from '../components/Navbar';

export default function ForumCategory() {
  return (
    <div className="min-h-screen bg-slate-50">
      <Navbar />
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <h1 className="text-2xl font-bold text-slate-900">Forum Category</h1>
        <p className="text-slate-600 mt-2">Use main Forum page with category filter for full functionality.</p>
      </main>
    </div>
  );
}
